import { createContext, useEffect, useState } from "react";
import Loader from "../components/common/Loader";
import { useNavigate } from "react-router-dom";

export const AuthContext = createContext();
export const LoaderContext = createContext();

const AuthProvider = ({ children }) => {
  const [authDetails, setAuthDetails] = useState({
    employeeName: "",
    password: "",
    token: "",
    userKeyID: "",
    roleTypeID: "",
    roleTypeName: "",
    emailID: "",
    canApprovedQuotation: null
  });
const getInitialTabs = () => {
  const savedTabs = localStorage.getItem("activeTabs");
  return savedTabs
    ? JSON.parse(savedTabs)
    : {
        Lead: { selectedTab: 0 },
        EnquiryReceived: { selectedTab: 0 },
        EstBoq: { selectedTab: 0 },
        Quotation: { selectedTab: 0 },
        SalesLog: { selectedTab: 0 },
        AccountLog: { selectedTab: 0 },
        FollowUp: { selectedTab: 0 },
        Company: { selectedTab: 0 },
        Country: { selectedTab: 0 },
        Customer: { selectedTab: 0 },
        Designation: { selectedTab: 0 },
        District: { selectedTab: 0 },
        DVR: { selectedTab: 0 },
        Employee: { selectedTab: 0 },
        MIDC: { selectedTab: 0 },
        Product: { selectedTab: 0 },
        Site: { selectedTab: 0 },
        State: { selectedTab: 0 },
        Taluka: { selectedTab: 0 },
        Unit: { selectedTab: 0 },
        Source: { selectedTab: 0 },
        TaskManagement: { selectedTab: 0 },
      };
};
const [activeTabs, setActiveTabs] = useState(getInitialTabs);

  const defaultPermissions = {
    Dashboard: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    Lead: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    EnquiryReceived: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    EstBoq: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    Quotation: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    SalesLog: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    AccountLog: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    FollowUp: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    Company: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    Country: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    Customer: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    Designation: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    District: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    DVR: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    Employee: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    MIDC: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    Product: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    Site: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    State: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    Taluka: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    Unit: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    Source: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    TermsAndCondition: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    RoleType: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    SetDefaultAccess: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },
    TaskManagement: { canView: false, canInsert: false, canUpdate: false, canTranfer: false, canExport: false },

  };

  const [isAccessible, setIsAccessible] = useState(() => {
    const savedPermissions = localStorage.getItem("userPermissions");
    return savedPermissions ? JSON.parse(savedPermissions) : defaultPermissions;
  });

  useEffect(() => {
    const permissionList = authDetails?.permissionModule || [];

    const updatedPermissions = { ...isAccessible };

    permissionList.forEach((value) => {
      const moduleMapping = {
        "Account Log": "AccountLog",
        "Enquiry Received": "EnquiryReceived",
        "EST & BOQ": "EstBoq",
        "Sales Log": "SalesLog",
        "Set Default Access": 'SetDefaultAccess',
        "Terms & Conditions": 'TermsAndCondition',
        "Task Manegment": "TaskManagement"
      };

      const module =
        moduleMapping[value.moduleName] || value.moduleName.replace(/\s+/g, "");
      console.log("module", module);

      if (updatedPermissions[module]) {
        if (value.mActionName === "Can View") {
          updatedPermissions[module].canView = value?.setDefaultAction;
        } else if (value.mActionName === "Can Insert") {
          updatedPermissions[module].canInsert = value?.setDefaultAction;
        } else if (value.mActionName === "Can Update") {
          updatedPermissions[module].canUpdate = value?.setDefaultAction;
        } else if (value.mActionName === "Can Transfer") {
          updatedPermissions[module].canTranfer = value?.setDefaultAction;
        } else if (value.mActionName === "Can Export") {
          updatedPermissions[module].canExport = value?.setDefaultAction;
        }
      }
    });

    setIsAccessible(updatedPermissions);
    localStorage.setItem("userPermissions", JSON.stringify(updatedPermissions));
  }, [authDetails]);

  useEffect(() => {
    // Set initial auth details from localStorage
    const storedAuth = JSON.parse(localStorage.getItem("login"));
    if (storedAuth) {
      setAuthDetails(storedAuth.logInItem);
    }
  }, []);

  const setLoginItem = (logInItem) => {
    setAuthDetails(logInItem);
    localStorage.setItem("login", JSON.stringify({ logInItem }));
  };

  const setTab = (moduleName, tabIndex) => {
  setActiveTabs((prevTabs) => {
    const updatedTabs = {
      ...prevTabs,
      [moduleName]: {
        ...prevTabs[moduleName],
        selectedTab: tabIndex,
      },
    };

    // ✅ persist after update
    localStorage.setItem("activeTabs", JSON.stringify(updatedTabs));

    return updatedTabs;
  });
};

  return (
    <AuthContext.Provider value={{ authDetails, setLoginItem, isAccessible, activeTabs, setActiveTabs, setTab }}>
      {children}
    </AuthContext.Provider>
  );
};
const LoaderProvider = ({ children }) => {
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();

  // const handleLogout = () => {
  //   // Clear local storage and perform logout logic
  //   setLoader(true); // Show loader during logout
  //   setTimeout(() => {
  //     localStorage.clear();
  //     setLoader(false); // Hide loader after logout
  //     navigate("/login");
  //     window.location.reload();
  //   }, 1000); // Simulate a delay for logout process
  // };

  return (
    <LoaderContext.Provider value={{ loader, setLoader }}>
      {children}
      {loader && <Loader />}
    </LoaderContext.Provider>
  );
};

export { LoaderProvider };
export default AuthProvider;
